<section class="cms-section" [ngClass]="{'new-section': showNew}" id="appCMSLinks-section-popularCities" *ngIf="links">
  <div class="cms-links" [ngClass]="{'full-height': showMore}">
    <h2 class="title">{{title}}</h2>
    <hr class="hide-on-mobile"/>
    <div class="links is-flex">
      <div *ngIf="links?.popularCities" class="current">
        <a *ngFor="let link of links?.popularCities" [routerLink]="link.url">
          {{ link.name || link.title }}
        </a>
      </div>
      <div *ngIf="links?.openHouses" class="current">
        <a *ngFor="let link of links.openHouses" [routerLink]="link.url">
          {{ link.name || link.title  }}
        </a>
      </div>
      <div *ngIf="links?.businessOpportunities" class="current">
        <a *ngFor="let link of links?.businessOpportunities" [routerLink]="link.url">
          {{ link.name || link.title }}
        </a>
    </div>
      <hr class="list-break"/>
      <div *ngIf="links?.agentCities" class="current">
        <a *ngFor="let link of links.agentCities" [routerLink]="link.url">
          {{ link.name || link.title }}
        </a>
      </div>
      <div *ngIf="links?.neighbourhoods" class="current">
          <a *ngFor="let link of links?.neighbourhoods" [routerLink]="link.url">
            {{ link.name || link.title }}
          </a>
      </div>


    </div>

    <div>
      <h2 class="title" translate="footer.newest-listings"></h2>
      <div class="newest-links">
        <span class="newest-link" *ngFor="let link of newestLinks; let i=index">
            <a href="{{endpoint}}real-estate-listings-canada?page={{i+1}}">{{link}}</a>
        </span>

      </div>
  </div>

  </div>
  <div class="show-more text-center">
      <span (click)="showMore = !showMore" role="button" tabindex="0" (keydown.enter)="showMore = !showMore">
        <span *ngIf="!showMore">{{ 'relevant-links.show-more-links' | translate }}
          <i class="material-icons v-align">keyboard_arrow_down</i>
        </span>
        <span *ngIf="showMore">{{ 'relevant-links.show-less-links' | translate }}
          <i class="material-icons v-align">keyboard_arrow_up</i>
        </span>
      </span>
  </div>
</section>
